<template>
  <div>
    <el-form ref="formRef" :model="nameForm" label-width="88px">
      <el-form-item label="昵称：">
        <el-input type="text" v-model="nameForm.nickname" placeholder="输入昵称" style="width:24em;"/>
        <p style="font-size: 12px; color: #aaaaaa;"><span style="color: red">* </span>昵称不能超过8个字</p>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateSysNickname } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      nameForm: this.value.nameForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.nameForm.nickname) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '昵称不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.nameForm.id;
      param['nickname'] = this.nameForm.nickname;
      postFormData(addOrUpdateSysNickname, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
